/* Saved diamonds — localStorage only. No account, no app, no backend.
   Deliberately soft: nothing here can break checkout or the catalogue.

   The one thing a generic wishlist gets wrong for us: every stone is unique, so a
   saved list WILL fill up with diamonds that have since sold. We store a snapshot
   of each stone at save time and re-check availability when the list is rendered,
   so a sold stone is shown honestly with a route to similar ones — rather than
   silently 404ing or pretending it's still buyable. */
(function () {
  var KEY = 'vaalberg_saved_diamonds';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }   // private mode / cleared storage / corrupt value
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100))); } catch (e) {}
    paintCounts();
  }
  function has(url) { return read().some(function (i) { return i.url === url; }); }

  function toggle(payload) {
    var list = read();
    var i = list.findIndex(function (x) { return x.url === payload.url; });
    if (i > -1) list.splice(i, 1);
    else list.unshift(Object.assign({ addedAt: Date.now() }, payload));
    write(list);
    return i < 0; // true = now saved
  }

  function paintCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
    // Singular/plural noun next to the count ("1 diamond", "3 diamonds"); the
    // words come from the section settings via data-one / data-many.
    document.querySelectorAll('[data-wish-noun]').forEach(function (el) {
      el.textContent = n === 1 ? (el.getAttribute('data-one') || 'diamond') : (el.getAttribute('data-many') || 'diamonds');
    });
  }

  function paintHearts(scope) {
    (scope || document).querySelectorAll('[data-wish]').forEach(function (btn) {
      var url = btn.getAttribute('data-wish-url');
      var on = url && has(url);
      btn.classList.toggle('is-on', !!on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from saved diamonds' : 'Save this diamond');
    });
  }

  // Delegated so it also covers rows the search page renders after load.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();          // never trigger the row's own link
    var payload;
    try { payload = JSON.parse(btn.getAttribute('data-wish-payload') || '{}'); } catch (err) { payload = {}; }
    if (!payload.url) return;
    toggle(payload);
    paintHearts();
    syncPage();   // on /pages/saved-diamonds: drop the row that was just removed
  });

  /* ---------- saved-diamonds page ---------- */
  // Copy for the list comes from the Theme Editor (section settings → data-*
  // attributes on [data-wishlist]); the strings here are only fallbacks.
  var T = {};
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readTexts(host) {
    var d = (host && host.dataset) || {};
    return {
      emptyText: d.emptyText || 'You haven’t saved any diamonds yet.',
      emptyLinkLabel: d.emptyLinkLabel || 'Browse diamonds →',
      emptyUrl: d.emptyLinkUrl || '/pages/search-diamonds',
      viewLabel: d.viewLabel || 'View →',
      goneLabel: d.goneLabel || 'Sold — see similar →',
      goneUrl: d.goneLinkUrl || '/pages/search-diamonds',
      removeTitle: d.removeTitle || 'Remove'
    };
  }
  function money(item) {
    if (item.priceText) return item.priceText;
    return item.price != null ? item.price : '';
  }

  function card(item, available) {
    var img = item.image
      ? '<img class="wl__img" src="' + item.image + '" alt="" loading="lazy" width="88" height="88">'
      : '<span class="wl__img wl__img--placeholder" aria-hidden="true">◇</span>';
    var gone = available === false;
    return '<div class="wl__row' + (gone ? ' wl__row--gone' : '') + '" data-wl-row="' + esc(item.url) + '">'
      + img
      + '<span class="wl__info"><span class="wl__title">' + (item.title || 'Diamond') + '</span>'
      + '<span class="wl__meta">' + [item.carat, item.color, item.clarity].filter(Boolean).join(' · ') + '</span></span>'
      + '<span class="wl__price">' + money(item) + '</span>'
      + (gone
          ? '<a class="wl__cta wl__cta--gone" href="' + esc(T.goneUrl || '/pages/search-diamonds') + '">' + esc(T.goneLabel || 'Sold — see similar →') + '</a>'
          : '<a class="wl__cta" href="' + item.url + '">' + esc(T.viewLabel || 'View →') + '</a>')
      + '<button type="button" class="wl__remove" data-wish data-wish-url="' + item.url
      + '" data-wish-payload=\'' + JSON.stringify(item).replace(/'/g, '&#39;') + '\' title="' + esc(T.removeTitle || 'Remove') + '">✕</button>'
      + '</div>';
  }

  function rowFor(host, url) {
    var rows = host.querySelectorAll('.wl__row');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-wl-row') === url) return rows[i];
    }
    return null;
  }

  // Keep the rendered list in step with localStorage after a heart is toggled.
  // Without this the removed stone stayed on screen until a reload, because the
  // click handler only rewrote the counter and the hearts.
  function syncPage() {
    var host = document.querySelector('[data-wishlist]');
    if (!host || !host.querySelector('.wl__row')) return;
    var saved = {};
    read().forEach(function (i) { saved[i.url] = true; });
    host.querySelectorAll('.wl__row').forEach(function (row) {
      var url = row.getAttribute('data-wl-row');
      if (url && !saved[url]) row.remove();
    });
    if (!host.querySelector('.wl__row')) {
      host.innerHTML = '<p class="wl__empty">' + esc(T.emptyText || 'You haven\u2019t saved any diamonds yet.') + ' '
        + '<a href="' + esc(T.emptyUrl || '/pages/search-diamonds') + '">' + esc(T.emptyLinkLabel || 'Browse diamonds \u2192') + '</a></p>';
    }
  }

  function renderPage() {
    var host = document.querySelector('[data-wishlist]');
    if (!host) return;
    T = readTexts(host);
    var list = read();
    if (!list.length) {
      host.innerHTML = '<p class="wl__empty">' + esc(T.emptyText) + ' '
        + '<a href="' + esc(T.emptyUrl) + '">' + esc(T.emptyLinkLabel) + '</a></p>';
      return;
    }
    host.innerHTML = list.map(function (i) { return card(i, null); }).join('');
    paintHearts(host);

    // Unique stones sell. Re-check each saved one and mark what's gone.
    list.forEach(function (item) {
      if (!item.url || item.url.indexOf('/products/') < 0) return;
      fetch(item.url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var available = p ? !!p.available : false;
          var row = rowFor(host, item.url);
          if (!row) return;            // removed while the request was in flight
          row.outerHTML = card(item, available);
          paintHearts(host);
        })
        .catch(function () {});
    });
  }

  function boot() { paintCounts(); paintHearts(); renderPage(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  window.VaalbergWishlist = { read: read, count: function () { return read().length; } };
})();
